// Copyright 2022 Sorama B.V.

import { HttpResponseMessage, RequestMessage } from "aurelia-http-client";
import { IWebRequestHandler, IWebRequestInterceptorHandler } from "libraries/WebRequestHandler/IWebRequestHandler";

export interface IBasicCredentials {
    domain: string;
    username: string;
    password: string;
}

export class BasicHTTPAuthentication implements IWebRequestInterceptorHandler {
    private readonly credentials: IBasicCredentials;

    constructor(webRequestHandler: IWebRequestHandler, credentials: IBasicCredentials) {
        this.credentials = credentials;
        webRequestHandler.addInterceptor(this.credentials.domain, this);
    }

    onSendRequest(request: RequestMessage): Promise<void> {
        return Promise.resolve(
            request.headers.add(
                "Authorization",
                "Basic " + btoa(this.credentials.username + ":" + this.credentials.password)
            )
        );
    }

    onReceiveResponse(request: HttpResponseMessage): Promise<void> {
        return Promise.resolve();
    }

    onResponseError(error: HttpResponseMessage): Promise<boolean> {
        return Promise.resolve(false);
    }
}
